import { Stack } from '@/ui/layout/Stack';
import { Box, CircularProgress, Text } from '@/ui/primitives';
import {
  LOADING_SPINNER_PAGE_FRAME_SX,
  LOADING_SPINNER_PAGE_SPINNER_SIZE,
  LOADING_SPINNER_PAGE_STACK_GAP,
  loadingSpinnerPageMessageSx,
} from './loadingSpinnerPageStyles';
import type { ReactElement } from 'react';

type LoadingSpinnerPageStateProps = {
  message: string;
};

export const LoadingSpinnerPageState = ({
  message,
}: LoadingSpinnerPageStateProps): ReactElement => (
  <Box sx={LOADING_SPINNER_PAGE_FRAME_SX}>
    <Stack gap={LOADING_SPINNER_PAGE_STACK_GAP} align="center">
      <Text role="body" color="textSecondary" align="center" sx={loadingSpinnerPageMessageSx}>
        {message}
      </Text>
      <CircularProgress size={LOADING_SPINNER_PAGE_SPINNER_SIZE} />
    </Stack>
  </Box>
);
